module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_1_4.12c20a30.png";